import { render, staticRenderFns } from "./Clipboard.vue?vue&type=template&id=120efbd0&"
import script from "./Clipboard.vue?vue&type=script&lang=ts&"
export * from "./Clipboard.vue?vue&type=script&lang=ts&"
import style0 from "./Clipboard.vue?vue&type=style&index=0&id=120efbd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports